import Vue from 'vue'
import cancellationUrlWithError from '~utils/psp-cancellation'

const WARNING_SESSION_TIMEOUT = 8.5 * 60 * 1000 // 8 minutes 30 seconds
const CLOSE_SESSION_TIMEOUT = 10 * 60 * 1000 // 10 minutes

interface Data {
  showSessionPopup: boolean;
  showSessionWarningTimeout: number | null;
  closeSessionTimeout: number | null;
}

export default Vue.extend({
  data(): Data {
    return {
      showSessionPopup: false,
      showSessionWarningTimeout: null,
      closeSessionTimeout: null,
    }
  },
  computed: {
    cancellationUrl(): string {
      return cancellationUrlWithError(this.$store.state.redemptions.redemption.cancellationUrl, 'SESSION_TIMEOUT')
    },
  },
  created() {
    this.setupEventListeners()
  },
  methods: {
    onModalInput(val: boolean) {
      if (!val) {
        this.keepSessionAlive()
      }
    },
    keepSessionAlive() {
      this.showSessionPopup = false
      this.updateLastActivity()
    },
    updateLastActivity() {
      if (this.showSessionWarningTimeout) {
        window.clearTimeout(this.showSessionWarningTimeout)
      }

      this.showSessionWarningTimeout = window.setTimeout(() => {
        this.showSessionPopup = true
      }, WARNING_SESSION_TIMEOUT)

      // Don't set a new timer if a user has the warning popup opened, keep the old one running
      // He has a minute to keep the session alive
      if (!this.showSessionPopup) {
        if (this.closeSessionTimeout) {
          window.clearTimeout(this.closeSessionTimeout)
        }

        this.closeSessionTimeout = window.setTimeout(() => {
          window.location.href = this.cancellationUrl
        }, CLOSE_SESSION_TIMEOUT)
      }
    },
    setupEventListeners() {
      window.addEventListener('click', this.updateLastActivity)
      window.addEventListener('touchstart', this.updateLastActivity)
      window.addEventListener('keyup', this.updateLastActivity)

      this.updateLastActivity()
    },
  },
})
